import { useEffect, useRef } from 'react';
const { registerBackLayer } = require('../utils/backNavigation');
export default function useBackLayer(open, close) {
  const closeRef = useRef(close); closeRef.current = close;
  useEffect(() => open ? registerBackLayer(() => closeRef.current()) : undefined, [open]);
}
